import { createRouter, createWebHistory } from 'vue-router';
import { SSO_FAILED_QUERY_VALUE } from '@/constants';

export const routes = [
  {
    path: '/',
    redirect: { name: 'login' },
  },
  {
    path: '/login',
    component: () => import('@layouts/auth-layout.vue'),
    children: [
      {
        path: '',
        name: 'login',
        component: () => import('@pages/login/login-page.vue'),
        is_public: true,
        meta: { title: 'Staff sign in' },
      },
    ],
  },
  {
    path: '/home',
    component: () => import('@layouts/default-layout.vue'),
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('@pages/home/home-page.vue'),
        kate_permissions: ['access_applicant_portal_staff'],
        meta: { title: 'Home' },
      },
      {
        path: 'applications/:applicationId',
        name: 'applicant-overview',
        component: () => import('@pages/applicant/applicant-overview.vue'),
        kate_permissions: ['access_applicant_portal_staff'],
        meta: { title: 'Applicant overview' },
        props: true,
      },
    ],
  },
  {
    path: '/403',
    component: () => import('@layouts/default-layout.vue'),
    children: [
      {
        path: '',
        name: '403',
        component: () => import('@pages/forbidden-page.vue'),
        meta: { title: 'Forbidden' },
      },
    ],
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('@layouts/default-layout.vue'),
    children: [
      {
        path: '',
        name: 'not-found',
        component: () => import('@pages/not-found-page.vue'),
        meta: { title: 'Page not found' },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(to => {
  if (to.query.error === SSO_FAILED_QUERY_VALUE && to.name !== 'login') {
    return { name: 'login', query: to.query };
  }
  return true;
});

router.afterEach(to => {
  document.title = to.meta?.title || 'KATE Applicant Portal Staff';
});

export default router;
